// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BackOrderModel, selectAltWarehouse as selectAltWarehouseApi } from "@guestsupply/App/Services/BackorderManagementService";
import { ApiHandler, createHandlerChainRunner, HasOnComplete, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{ backorder: BackOrderModel } & HasOnSuccess & HasOnError, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {...props.parameter};
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await selectAltWarehouseApi(props.apiParameter.backorder);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const selectAltWarehouse = createHandlerChainRunner(chain, "SelectAltWarehouse");
export default selectAltWarehouse;
